import { FeedbackReason } from 'graph_ql/feedback/types';
import { groupBy } from 'lodash';

export const flattenFeedbackOptions = (options: FeedbackReason[]) => {
    // Convert non-category to others
    const handledOptions = options?.map((option) => {
        if (!option.category) {
            return { ...option, category: { id: 'other', title: 'Other', displayOrder: 40 } };
        }
        return option;
    });
    let categories = groupBy(handledOptions, (option) => option.category?.title);
    let categorizedOptions = Object.keys(categories).map((key) => ({
        category: key,
        order: categories[key][0].category?.displayOrder,
        options: categories[key],
    }));
    categorizedOptions = categorizedOptions.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
    return categorizedOptions;
};
